import Vue from 'vue'

import prepareApplication from 'app/bootstrap'
import prepareComponents from 'components/bootstrap'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Breadcrumb from 'dd/Breadcrumb'

(async () => {
  Vue.config.productionTip = false
  Vue.use(BootstrapVue)
  Vue.use(Breadcrumb)
  await prepareApplication()
  await prepareComponents()

  new Vue({
    store: require('store').default,
    router: require('router').default,
    i18n: require('translations').default,
    render: h => h(require('./App').default)
  }).$mount('#app')
})()
